//@flow
import Enum from 'common/enums/Enum';
import I18nHelper from 'common/helpers/I18nHelper';
const translationsNamespace = ['entityManagement'];

const nsTranslate = I18nHelper.getTranslate(translationsNamespace);
type optionLabelType = { value: string, label: string };
class EntityTypeEnum extends Enum {
    createNew(args: { [key: string]: string }) {
        return new EntityTypeEnum(args);
    }

    optionFormatter = ({ value, label }: optionLabelType): optionLabelType => ({
        value,
        label
    });

    getOptions({
        translationKey,
        optionFormatter = this.optionFormatter
    }: {
        translationKey: string,
        optionFormatter?: optionLabelType => optionLabelType | any
    }): Array<{ value: string, label: string }> {
        return this.values().map(value => {
            return optionFormatter({
                value,
                label: nsTranslate(`${translationKey}.${value}`)
            });
        });
    }
}

export { EntityTypeEnum };
export default EntityTypeEnum;
